import axios from "axios";
import { configUrl } from "config.js";

const getTestDetailsForPdf = async (testId) => {
    try {
        let Response = await axios.get(
            `${configUrl.AssessmentServer}/api/questions/pdfBasedTestAnswers/${testId}`,
        );

        let TestData = Response?.data;
        return TestData;
    } catch (error) {
        console.error("API Error:", error);
        throw error;
    }
};
export default {
    getTestDetailsForPdf: getTestDetailsForPdf,
};
